import React, { Suspense } from 'react';

import BookmarksLoadingState from './BookmarksLoadingState';

const Bookmarks = React.lazy(() => import(/* webpackChunkName: "Bookmarks" */ './Bookmarks'));

const LocalStorageBookmarkProvider = React.lazy(() => import(/* webpackChunkName: "Bookmarks" */ './data/LocalStorageBookmarksProvider'));

export default class BookmarksLoader {
    constructor(config) {
        this.config = this._parseConfiguration(config);
    }

    getComponent() {
        const component = <Bookmarks {...this.config} />;
        const dataProvider = this._getDataProvider(component);

        return <Suspense fallback={<BookmarksLoadingState {...this.config} />}>{dataProvider}</Suspense>;
    }

    _parseConfiguration(config) {
        return {
            ...config,
        };
    }

    _getDataProvider(component) {
        return <LocalStorageBookmarkProvider>{component}</LocalStorageBookmarkProvider>;
    }
}
